module.exports = __webpack_public_path__ + "img/expand-more.85ff1d3d.svg";